import store from '@/store';

const REPRESENTATIVE_ROLES = [
    'ADMINISTRADOR',
    'APODERADO',
    'AUTORIZADO',
    'JUNTA_DIRECTIVA',
    'PATRONO',
    'REPRESENTANTE_LEGAL',
    'TITULAR_REAL',
    'TUTOR',
    'USUFRUCTUARIO'
];

const getRolesNeedConvenience = async () => {
    const rolesDefinition = await store.dispatch('rolesDefinition');
    const rolesNeedConvenience = rolesDefinition
        .filter(role => role.is_need_convenience)
        .map(role => role.key_name);

    return rolesNeedConvenience;
};

const getRolesNeedFatcaCrs = async () => {
    const rolesDefinition = await store.dispatch('rolesDefinition');
    const rolesNeedFatcaCrs = rolesDefinition
        .filter(role => role.is_need_fatca)
        .map(role => role.key_name);

    return rolesNeedFatcaCrs;
};

const getRolesNeedKyc = async () => {
    const rolesDefinition = await store.dispatch('rolesDefinition');
    const rolesNeedKyc = rolesDefinition
        .filter(role => role.is_need_kyc)
        .map(role => role.key_name);

    return rolesNeedKyc;
};

const hasEntitySomeRole = (intervener, keys) => {
    return (intervener.roles && intervener.roles?.some(role => keys.includes(role.key))) || false;
};

export default {
    REPRESENTATIVE_ROLES,
    getRolesNeedConvenience,
    getRolesNeedFatcaCrs,
    getRolesNeedKyc,
    hasEntitySomeRole
};
